import { Routes } from '@angular/router';
import { ProductCatalogComponent } from './product-catalog.component';
import { ProductDetailsComponent } from './product-details.component';
import { MobileLoginComponent } from './mobile-login.component';
import { MobileDashboardComponent } from './mobile-dashboard.component';
import { MobileCartComponent } from './mobile-cart.component';
import { MobileProductDetailsComponent } from './mobile-product-details.component';
import { mobileAuthGuard } from './mobile-auth.guard';

export const routes: Routes = [
	{ path: '', component: ProductCatalogComponent },
	{ path: 'products/:id', component: ProductDetailsComponent },
	{ path: 'mobile/login', component: MobileLoginComponent },
	{ path: 'mobile/dashboard', component: MobileDashboardComponent, canActivate: [mobileAuthGuard] },
	{ path: 'mobile/products/:id', component: MobileProductDetailsComponent, canActivate: [mobileAuthGuard] },
	{ path: 'mobile/cart', component: MobileCartComponent, canActivate: [mobileAuthGuard] },
	{ path: '**', redirectTo: '' },
];
